import React, { FC, ReactNode } from 'react';
import Button from './Button';

type DialogAction = {
    label: string;
    onClick: () => void;
    cssName?: string;
};

type DialogProps = {
    open: boolean;
    setOpen: (open: boolean) => void;
    title: string;
    message?: string;
    children?: ReactNode;
    actions: DialogAction[];
};
const Dialog: FC<DialogProps> = ({ open, setOpen, title, message, actions, children }) => {
    if (!open) return null;

    const handleClickOutside = (e: React.MouseEvent<HTMLDivElement>): void => {
        if (e.target === e.currentTarget) {
            // Close the dialog if clicked outside
            setOpen(false);
        }
    };

    return (
        <div
            className="component-dialog dialog-overlay"
            onClick={handleClickOutside}
        >
            <div className="dialog-content">
                <div className="dialog-header">
                    <h2>{title}</h2>
                </div>
                <div className="dialog-message">{message ? <p>{message}</p> : null}</div>
                {children}
                <div className="dialog-actions">
                    {actions.map((action, index) => (
                        <Button
                            key={`${action.label}-${index}`}
                            onClick={action.onClick}
                            cssName={action?.cssName}
                        >
                            {action.label}
                        </Button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Dialog;
